module.exports = __webpack_public_path__ + "img/p6.d58a91e9.png";